// src/api/queues/services.ts
import { ENV } from "../../config/runtimeEnv";

export interface QueueService {
	key: string;
	label: string;
	// The service's same-origin base (`/api/<svc>`, contract §22), or undefined when the clinic has not configured it.
	baseUrl: string | undefined;
}

// identity has no queues or cache (contract §15 rows 201–212), so authentication is no longer listed.
export const queueServices = (): QueueService[] => [
	{ key: "labiq", label: "LabIQ", baseUrl: ENV.VITE_LABIQ_SERVER },
	{ key: "commerce", label: "Commerce", baseUrl: ENV.VITE_COMMERCE_SERVER },
	{ key: "healthcare", label: "Healthcare", baseUrl: ENV.VITE_HEALTHCARE_SERVER },
	{ key: "file", label: "File", baseUrl: ENV.VITE_FILE_SERVER },
	{ key: "notification", label: "Notification", baseUrl: ENV.VITE_NOTIFICATION_BASE_URL },
];
